import { APPT_STATUS, REQUEST_STATUS } from "@/lib/format";

const TONES = {
  blue: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  amber: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  purple: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  green: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  red: "bg-red-500/15 text-red-300 border-red-500/30",
  slate: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

export const StatusBadge = ({ status, kind = "request", testId }) => {
  const map = kind === "request" ? REQUEST_STATUS : APPT_STATUS;
  const s = map[status] || { label: status || "—", tone: "slate" };
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${TONES[s.tone]}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
};
